import { all } from 'redux-saga/effects';
import operationsSagas from './operationsSagas';

export default function* rootSaga() {
	yield all([
		operationsSagas()
	]);
}
